module.exports = __webpack_public_path__ + "img/Kisten_2.a3b12cc.png";